import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Swatches from '../Swatches';

const Container = styled.div``;

const Button = styled.button`
  width: 100%;
  text-align: center;
  height: 36px;
  margin: 20px 8px auto auto;
  border: 1px solid #8c8783;
  outline: 0;
  color: #7d7773;
  background-color: transparent;
  display: inline-block;
  font-family: HelveticaNeueLTPro-Roman;
  font-size: 13px;
  line-height: 36px;
  padding: 0 20px;
  cursor: pointer;
  text-transform: uppercase;
  :active {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
  :focus {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
  :hover {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
`;

const Note = styled.p`
  text-transform: none;
  font-family: HelveticaNeueLTPro-Roman;
  color: #7d7773;
  font-size: 0.7em;
  line-height: 1.4;
  width: 70%;
`;

export default class Upholstery extends PureComponent {
  uploadFile() {
    const fileEl = this.refs.fileUpload;
    fileEl.click();
  }

  importImage(e, data) {
    const file = e.target.files[0];
    const { importImage } = this.props;
    importImage('UpholsteryImage', file);
  }

  render() {
    const {
      currentSelection,
      setCurrentSelection,
      images,
      upholstery,
    } = this.props;
    const active = currentSelection['Upholstery'];
    if (!images) return null;
    return (
      <Container>
        <Swatches
          selectKey="Upholstery"
          col={4}
          images={images}
          active={active}
          onClick={setCurrentSelection}
          attribute={upholstery}
        />
        <Button onClick={this.uploadFile.bind(this)}>upload png or jpg</Button>
        <input
          type="file"
          style={{ display: 'none' }}
          onChange={this.importImage.bind(this)}
          ref="fileUpload"
        />
        <Note>
          Any uploaded images should be your orignial content or content you
          have permission to use
        </Note>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accords/Upholstery.js